module.exports = __webpack_public_path__ + "img/icon_info_cmt.509e5e71.svg";